<template>
  <v-app id="main-app-wrapper">
    <MainNavigation />
    <v-main v-if="userObjectLoaded">
      <router-view class="page-wrapper" :key="$route.path" />
    </v-main>
    <SnackBar />
    <Loader />
    <Footer :appVersion="appVersion" />
  </v-app>
</template>

<script>
import MainNavigation from '@/components/generic/main-navigation/main-navigation.vue';
import SnackBar from '@/components/generic/snackbar.vue';
import Loader from '@/components/generic/main-loader.vue';
import Footer from '@/components/generic/footer.vue';
import { routesData } from '../dashboard-config/routes-config.js';
import { dashboardConfig } from '../dashboard-config/dashboard-config.js';
import '@/assets/scss/generic.scss';
export default {
  name: 'App',

  components: {
    MainNavigation,
    SnackBar,
    Loader,
    Footer
  },
  data: () => ({
    appVersion: process.env.VUE_APP_TAG_VERSION,
    userObjectLoaded: false
  }),
  computed: {
    userObject() {
      return this.$store.state.config.userObject;
    }
  },
  watch: {
    userObject: {
      immediate: true,
      handler(n) {
        if (n) {
          setTimeout(() => {
            this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
          }, 100);
          this.userObjectLoaded = true;
        }
      }
    }
  },
  created() {
    this.initCustomComponentConfig(); //used to hide components if needed in children dashboards
    this.initCustomDashboardConfig(); //set dashboard logo, slug, etc
    this.$store.commit('SET_SHOW_LOADER', {
      action: true,
      text: 'One moment please...'
    });
  },
  mounted() {
    this.handleInternetConnectivity();
    if (this.userObject) this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
  },
  methods: {
    handleInternetConnectivity() {
      window.addEventListener('offline', () => {
        let payload = {
          open: true,
          text: 'No internet connection',
          color: 'error'
        };
        this.$store.commit('SET_SNACKBAR', payload);
      });

      window.addEventListener('online', () => {
        let payload = {
          open: true,
          text: 'Back online',
          color: 'success'
        };
        this.$store.commit('SET_SNACKBAR', payload);
      });
    },
    initCustomComponentConfig() {
      const customComponentConfig = routesData.reduce((prev, route) => {
        prev[route.name] = route.customComponents;
        return prev;
      }, {});
      this.$store.commit('SET_CUSTOM_COMPONENT_CONFIG', customComponentConfig);
    },
    initCustomDashboardConfig() {
      this.$store.commit('SET_CUSTOM_DASHBOARD_CONFIG', dashboardConfig);
      //set page title
      document.title = this.$store.state.config.customDashboardConfig.appTitle;
    }
  }
};
</script>

<style lang="scss">
.v-input--is-disabled {
  input,
  textarea {
    color: rgba(0, 0, 0, 0.8) !important;
  }
}
.border-bottom-light {
  border-bottom: 1px solid #e0e0e0;
}

.bg-whitesmoke {
  background: #d9eaf2 !important;
}
.bg-white {
  background: #fff !important;
}

// vuetify only has till mb-16 = 64px
.mb-17 {
  margin-bottom: 68px;
}
.mb-18 {
  margin-bottom: 72px;
}
.mb-19 {
  margin-bottom: 76px;
}
.mb-20 {
  margin-bottom: 80px;
}
</style>
